import type { WavEncoder } from "./wav-encoder";

export class ManualWavEncoder implements WavEncoder {
  encodePCM16Mono(samples: Int16Array, sampleRate: number): Blob {
    const channels = 1;
    const bitsPerSample = 16;
    const wavHeaderSize = 44;
    const bytesPerSample = bitsPerSample / 8;
    const dataSize = samples.length * bytesPerSample;

    const buffer = new ArrayBuffer(wavHeaderSize + dataSize);
    const view = new DataView(buffer);

    writeString(view, 0, "RIFF");
    view.setUint32(4, 36 + dataSize, true);
    writeString(view, 8, "WAVE");
    writeString(view, 12, "fmt ");
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, channels, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * channels * bytesPerSample, true);
    view.setUint16(32, channels * bytesPerSample, true);
    view.setUint16(34, bitsPerSample, true);
    writeString(view, 36, "data");
    view.setUint32(40, dataSize, true);

    let offset = wavHeaderSize;
    for (let i = 0; i < samples.length; i++) {
      view.setInt16(offset, samples[i], true);
      offset += 2;
    }
    return new Blob([buffer], { type: "audio/wav" });
  }
}

function writeString(view: DataView, offset: number, str: string) {
  for (let i = 0; i < str.length; i++) view.setUint8(offset + i, str.charCodeAt(i));
}
